"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _shadows = require("../shadows");
var styleOverrides = {
    badge: function(param) {
        var ownerState = param.ownerState;
        return _object_spread({
            boxShadow: 'none',
            border: "1px solid ".concat(_constants.colors.commonColors.white),
            fontSize: '1rem',
            letterSpacing: 0,
            lineHeight: 1.5,
            height: 22,
            minWidth: 22,
            borderRadius: 11,
            padding: '0 3px',
            top: '20%'
        }, ownerState.color === 'default' && {
            backgroundColor: _constants.colors.commonColors.white,
            color: _constants.colors.text.primary,
            boxShadow: _shadows.SHADOW_LEVEL3
        });
    },
    dot: {
        width: 10,
        height: 10,
        minWidth: 'unset',
        borderRadius: '50%',
        padding: 0
    }
};
var defaultProps = {
    color: 'default',
    overlap: 'circular'
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiBadge.js.map
